module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "limiter"
  }, [_c('div', {
    staticClass: "container-login100"
  }, [_c('div', {
    staticClass: "wrap-login100"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "login100-form validate-form"
  }, [_vm._m(1), _vm._v(" "), (_vm.forgetPassword == false) ? _c('div', {
    staticClass: "wrap-input100 validate-input",
    attrs: {
      "data-validate": "Valid email is required: ex@abc.xyz"
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.credentials.email),
      expression: "credentials.email"
    }],
    staticClass: "input100",
    class: {
      input: true,
        'is-danger': _vm.errors.has('email'),
    },
    attrs: {
      "data-vv-delay": "1000",
      "name": "email",
      "type": "text",
      "placeholder": "Email"
    },
    domProps: {
      "value": (_vm.credentials.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.credentials, "email", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "focus-input100"
  }), _vm._v(" "), _vm._m(2)]) : _vm._e(), _vm._v(" "), (_vm.forgetPassword == false) ? _c('div', {
    staticClass: "wrap-input100 validate-input",
    attrs: {
      "data-validate": "Password is required"
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:6'),
      expression: "'required|min:6'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.credentials.password),
      expression: "credentials.password"
    }],
    staticClass: "input100",
    class: {
      input: true,
        'is-danger': _vm.errors.has('password'),
    },
    attrs: {
      "data-vv-delay": "5000",
      "name": "password",
      "type": "password",
      "placeholder": "Password"
    },
    domProps: {
      "value": (_vm.credentials.password)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.submit()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.credentials, "password", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "focus-input100"
  }), _vm._v(" "), _vm._m(3)]) : _vm._e(), _vm._v(" "), (_vm.forgetPassword == true) ? _c('div', [_c('p', [_vm._v("Enter your E-Mail ID")]), _vm._v(" "), _c('div', {
    staticClass: "wrap-input100 validate-input",
    attrs: {
      "data-validate": "E-Mail is required"
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:6'),
      expression: "'required|min:6'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.resetEmailID),
      expression: "resetEmailID"
    }],
    staticClass: "input100",
    class: {
      input: true,
        'is-danger': _vm.errors.has('email'),
    },
    attrs: {
      "data-vv-delay": "5000",
      "name": "email",
      "type": "email",
      "placeholder": "E-Mail"
    },
    domProps: {
      "value": (_vm.resetEmailID)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.resetPassword()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.resetEmailID = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "focus-input100"
  }), _vm._v(" "), _vm._m(4)]), _vm._v(" "), _c('div', {
    staticClass: "back-login textAlign"
  }, [_c('button', {
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        return _vm.backLogin()
      }
    }
  }, [_vm._v("\n                                Back to Login\n                            ")])]), _vm._v(" "), _c('div', {
    staticClass: "container-login100-form-btn"
  }, [_c('button', {
    staticClass: "login100-form-btn",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        return _vm.resetPassword()
      }
    }
  }, [_vm._v("\n                                Submit\n                            ")])])]) : _vm._e(), _vm._v(" "), (_vm.forgetPassword == false) ? _c('div', {
    staticClass: "textAlign"
  }, [_c('button', {
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        return _vm.forgetpassword()
      }
    }
  }, [_vm._v("\n                            Forgot Password?\n                        ")])]) : _vm._e(), _vm._v(" "), (_vm.forgetPassword == false) ? _c('div', {
    staticClass: "container-login100-form-btn"
  }, [_c('button', {
    staticClass: "login100-form-btn",
    attrs: {
      "type": "submit",
      "disabled": !_vm.formValid
    },
    on: {
      "click": function($event) {
        return _vm.submit()
      }
    }
  }, [_vm._v("\n                            Login\n                        ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "text-center p-t-12"
  })])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login100-pic js-tilt",
    attrs: {
      "data-tilt": ""
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/Blue-Yeti.png",
      "alt": "IMG"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "login100-form-title"
  }, [_c('img', {
    attrs: {
      "src": "https://nivid.automatad.com/assets/img/logo-white-md.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "symbol-input100"
  }, [_c('i', {
    staticClass: "fa fa-envelope",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "symbol-input100"
  }, [_c('i', {
    staticClass: "fa fa-lock",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "symbol-input100"
  }, [_c('i', {
    staticClass: "fa fa-lock",
    attrs: {
      "aria-hidden": "true"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-29d8954b","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/auth/Login.vue
// module id = 665
// module chunks = 2